import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      docplanner: {
         docplannerInstitutionName: 'Nazwa placówki w Znanym Lekarzu',
         integration: {
            apiKey: 'Klucz API',
            apiSecret: 'Hasło API',
            docplannerConfigurationFetchError: 'Wystąpił problem z połączeniem. Spróbuj ponownie później.',
            docplannerConfigurationFetchSuccess: 'Poprawnie zalogowano do portalu Znany Lekarz',
            doctorsMappings: {
               associationDataHasBeenSaved: 'Dane powiązań zostały zapisane.',
               choose: 'Wybierz',
               chooseOrLeaveEmpty: 'Wybierz albo pozostaw puste',
               docplannerPractitioners: 'Specjaliści w Znanym Lekarzu',
               eGabinetAssociation: 'Przypisanie w eGabinet',
               editAssociationModalTitle: 'Edytuj powiązania - {{lastName}} {{firstName}}',
               egabinetMUS: 'Miejsce Udzielania Świadczeń w eGabinet',
               facilities: 'Placówki',
               healthcareProviderLocationsFetchFault: 'Nie udało się listy placówek. <retryLink />',
               label: 'Specjaliści i placówki',
               practitionersFetchFault: 'Nie udało się pobrać listy specjalistów. Spróbuj ponownie później',
               retry: 'Spróbuj ponownie.',
               save: 'Zapisz',
            },
            incorrectPassword: 'Niepoprawne hasło',
            integrationConfiguration: 'Konfiguracja integracji',
            lastValidSynchronization: 'Data ostatniej synchronizacji',
            medicalServicesMappings: {
               addMapping: 'Powiąż usługę',
               addNewMapping: 'Dodaj nowe powiązanie',
               areYouSureLeavingForm: 'Czy chcesz wyjść z formularza? <suffix />',
               areYouSureRemoveMapping: 'Czy na pewno chcesz usunąć powiązanie poniższych usług?',
               chooseDocplannerService: 'Wybierz usługę w Znanym Lekarzu',
               chooseReceptionService: 'Wybierz usługę recepcyjną',
               docplannerService: 'Usługa w Znanym Lekarzu',
               docplannerServiceWithName: 'Usługa w Znanym Lekarzu: <docplannerServiceName />',
               leave: 'Wyjdź',
               map: 'Powiąż',
               mapServicesToMakePatientsAbleToRegister:
                  'Powiąż usługi, by pacjenci mogli się na nie rejestrować przez Znanego Lekarza.',
               mappingCreated: 'Powiązanie usług zostało dodane.',
               mappingRemoved: 'Powiązanie usług zostało usunięte.',
               noMappings: 'Brak powiązanych usług',
               receptionService: 'Usługa recepcyjna',
               receptionServicePrice: 'Cena usługi recepcyjnej',
               receptionServiceWithName: 'Usługa recepcyjna: <receptionServiceName />',
               remove: 'Usuń',
               removingMapping: 'Usuwasz powiązanie usług',
               serviceAlreadyMapped:
                  'Usługa recepcyjna ma już swoje powiązanie do innej usługi w portalu Znany Lekarz.',
               services: 'Usługi',
               unsavedDataWillBeLost: 'Utracisz niezapisane dane.',
               youAreLeavingForm: 'Wychodzisz z formularza',
            },
            newClientSecret: 'Nowe hasło API',
            passwordHasBeenUpdated: 'Hasło zostało zaktualizowane.',
            save: 'Zapisz',
            synchronizationDaysCount: 'Liczba dni synchronizacji kalendarza',
            synchronizationDaysCountDescription:
               'Liczba dni z przyszłości (z przedziału 1-160), dla których nastąpi synchronizacja zdefiniowanych wolnych slotów czasowych z usługą Znany Lekarz.',
            synchronizationDaysCountHasBeenUpdated: 'Liczba dni synchronizacji kalendarza została zaktualizowana.',
            updateApiSecret: 'Zaktualizuj hasło',
            updateDaysCount: 'Edytuj liczbę dni',
            updateSynchronizationDaysCount: 'Edytuj liczbę dni synchronizacji',
            wrongApiKeyOrPassword: 'Niepoprawny klucz lub hasło.',
         },
         validations: {
            serviceProvidingLocationIsNotAssociatedWithDocplanner:
               'Placówka nie jest powiązana z placówką w portalu Znany Lekarz.',
         },
      },
   },
};

export const docplannerTranslationKeys = createScopedTranslationKeys(translations.pl, 'docplanner');
export const integrationTranslationKeys = docplannerTranslationKeys.integration;
export const doctorsMappingsTranslationKeys = integrationTranslationKeys.doctorsMappings;
export const medicalServicesMappingsTranslationKeys = integrationTranslationKeys.medicalServicesMappings;
